import { api } from "./api-client";

export interface Notification {
  id: string;
  user_id: string;
  type: string;
  title: string;
  message: string;
  action_url: string | null;
  action_data: Record<string, unknown> | null;
  read: boolean;
  created_at: string;
  updated_at: string;
}

export async function getNotifications(limit: number = 20): Promise<Notification[]> {
  return api.get<Notification[]>(`/notifications?limit=${limit}`);
}

export async function getUnreadCount(): Promise<number> {
  const result = await api.get<{ count: number }>("/notifications/unread-count");
  return result.count;
}

export async function markAllRead(): Promise<void> {
  await api.put("/notifications/mark-all-read", {});
}

export async function dismissNotification(id: string): Promise<void> {
  await api.delete(`/notifications/${id}`);
}

export async function clearAllNotifications(): Promise<void> {
  await api.delete("/notifications");
}
